<div   class="w-100 mb-20 mct-flex mct-row mct-justify-between mct-items-center">
  <h4>{{ 'revenue.pledge.edit.invoices.title' | translate | titlecase }}</h4>
  <div *ngIf="pledge">
    <a [routerLink]="'/revenue/invoice/new'" [queryParams]="{ profileId: pledge.ProfileId, pledgeId: pledge.PledgeId }">
      <button pButton type="button" *wlAccessControl="securityElementNames.fullAccess(securityElementNames.Manage_Revenue_Codes)"
         class="mct-flex atlas-btn atlas-btn-primary add-button mct-justify-center mct-items-center" type="button">
        <i class="large-icon pi pi-plus"></i>
        {{ 'revenue.pledge.edit.invoices.add-header' | translate | uppercase }}
      </button></a>
  </div>
</div>

<div class="atlas-table">
  <p-table [showGridlines]="true" [value]="searchResult?.Result" [paginator]="true" [rows]="searchParams ? searchParams.PageSize : 20" [lazy]="true" [totalRecords]="searchResult?.TotalCount" (onLazyLoad)="lazyLoad($event)" [filterDelay]="500">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="InvoiceLineItemInvoiceNum">
          {{ 'revenue.pledge.edit.invoices.invoice-number' | translate | titlecase }}
          <p-sortIcon field="InvoiceLineItemInvoiceNum"></p-sortIcon>
        </th>
        <th pSortableColumn="RevenueItemsItemName">
          {{ 'revenue.pledge.edit.invoices.revenue-item' | translate | titlecase }}
          <p-sortIcon field="RevenueItemsItemName"></p-sortIcon>
        </th>
        <th pSortableColumn="InvoiceLineItemApplyDate">
          {{ 'revenue.pledge.edit.invoices.apply-date' | translate | titlecase }}
          <p-sortIcon field="InvoiceLineItemApplyDate"></p-sortIcon>
        </th>
        <th pSortableColumn="AdjustedLineItemAmount">
          {{ 'revenue.pledge.edit.invoices.amount' | translate | titlecase }}
          <p-sortIcon field="AdjustedLineItemAmount"></p-sortIcon>
        </th>
        <th pSortableColumn="AdjustedPaymentAmount">
          {{ 'revenue.pledge.edit.invoices.amount-paid' | translate | titlecase }}
          <p-sortIcon field="AdjustedPaymentAmount"></p-sortIcon>
        </th>
        <th pSortableColumn="LastPaymentDate">
          {{ 'revenue.pledge.edit.invoices.date-paid' | translate | titlecase }}
          <p-sortIcon field="LastPaymentDate"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoiceLineItem>
      <tr>
        <td>
          <a [routerLink]="['/revenue/invoice', invoiceLineItem.InvoiceLineItemInvoiceNum]">{{
            invoiceLineItem.InvoiceLineItemInvoiceNum
            }}</a>
        </td>
        <td>{{ invoiceLineItem.RevenueItemsItemName }}</td>
        <td>{{ invoiceLineItem.InvoiceLineItemApplyDate | date : 'MM/dd/yyyy' }}</td>
        <td><span>$</span>{{ invoiceLineItem.AdjustedLineItemAmount }}</td>
        <td><span>$</span>{{ invoiceLineItem.AdjustedPaymentAmount }}</td>
        <td>{{ invoiceLineItem.LastPaymentDate | date : 'MM/dd/yyyy' }}</td>
      </tr>
    </ng-template>
  </p-table>
<p-progressSpinner *ngIf="loading"></p-progressSpinner>
  <wl-page-size-dropdown [(pageSize)]="searchParams.PageSize" [pageSizes]="[20, 100, 0]"
    (pageSizeChange)="pageSizeChanged()"></wl-page-size-dropdown>
</div>